import { MaintenanceService } from '@/src/app/core/maintenance/maintenance.service';
import { SpinnerService } from '@/src/app/shared/components/spinner/service/spinner.service';
import { maintenancePageRoute } from '@/src/app/utils/routing.utils';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class MaintenanceInterceptor implements HttpInterceptor {
  private readonly router = inject(Router);
  private readonly spinnerService = inject(SpinnerService);
  private readonly maintenanceService = inject(MaintenanceService);

  maintenancePageFullRoute = `/${maintenancePageRoute}`;

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError(errorResponse => {
        if (MaintenanceService.isStxMaintenanceMessage(errorResponse)) {
          this.maintenanceService.setMessage(errorResponse);
          if (!window.location.pathname.startsWith(this.maintenancePageFullRoute)) {
            this.spinnerService.clearTasks();
            this.router.navigateByUrl(this.maintenancePageFullRoute);
          }
        }
        return throwError(() => errorResponse);
      })
    );
  }
}
